/*
 * @Author: yannis yannis2473@163.com
 * @Date: 2025-04-14 15:20:21
 * @LastEditors: yannis yannis2473@163.com
 * @LastEditTime: 2025-07-08 14:43:47
 * @FilePath: \crm-admin-vue\src\api\admin\config.js
 * @Description: Do not edit
 * Copyright (c) 2025 by 久雀商业/Yannis, All Rights Reserved.
 */
import request from '@/utils/request';

/**
 * 企业首页
 * @param {*} data
 */
export function adminSystemSaveAPI(data) {
  return request({
    url: 'admin/system/save',
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  });
}

/**
 * 企业首页
 * @param {*} data
 */
export function adminSystemIndexAPI(data) {
  return request({
    url: 'admin/system/index',
    method: 'post',
    data: data
  });
}

// 代理区域设置列表
export function getAgentRegionList(data) {
  return request({
    url: 'admin/users/agentRegionList',
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  });
}

// 添加代理区域
export function agentRegionAdd(data) {
  return request({
    url: 'admin/users/agentRegionAdd',
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  });
}

// 编辑代理区域
export function agentRegionEdit(data) {
  return request({
    url: 'admin/users/agentRegionEdit',
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  });
}

// 查询上级代理区域
export function searchParentAgent(region_id) {
  return request({
    url: 'admin/users/searchParentAgent',
    method: 'post',
    data: { region_id },
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  });
}

// 获取代理详情数据
export function agentRegionInfo(user_id) {
  return request({
    url: 'admin/users/agentRegionInfo',
    method: 'post',
    data: { user_id },
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  });
}

// 员工惩罚配置列表
export function cluePunishment(params = {}) {
  return request({
    url: 'admin/userPunishment/cluePunishment',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  });
}

// 新增线索惩罚
export function cluePunishmentAdd(params = {}) {
  return request({
    url: 'admin/userPunishment/cluePunishmentAdd',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  });
}

// 编辑线索惩罚
export function cluePunishmentEdit(params = {}) {
  return request({
    url: 'admin/userPunishment/cluePunishmentEdit',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  });
}

// 删除线索惩罚
export function cluePunishmentDel(id = '') {
  return request({
    url: 'admin/userPunishment/cluePunishmentDel',
    method: 'post',
    data: { id },
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  });
}

// 线索惩罚切换生效状态
export function cluePunishmentActive(id = '') {
  return request({
    url: 'admin/userPunishment/cluePunishmentActive',
    method: 'post',
    data: { id },
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  });
}
